
import rubyLogo from '../../../images/rubyLogo.svg';

const Logo = () => {
  return (
    <img src={rubyLogo} alt=""/>
  )
}

export { Logo }